import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import UploadPage from "@/pages/UploadPage";
import Unmatched from "@/pages/Unmatched";
import PairMaster from "@/pages/PairMaster";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import Trends from "@/pages/Trends";
import TrainWise from "@/pages/TrainWise";
import { WeekProvider } from "@/context/WeekContext";

function App() {
  return (
    <WeekProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<TrainWise />} />
            <Route path="pair-analysis" element={<Dashboard />} />
            <Route path="upload" element={<UploadPage />} />
            <Route path="unmatched" element={<Unmatched />} />
            <Route path="trends" element={<Trends />} />
            <Route path="pairs" element={<PairMaster />} />
            <Route path="settings" element={<Settings />} />
            <Route path="audit" element={<AuditLog />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </WeekProvider>
  );
}

export default App;
